import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, catchError } from "rxjs";
import { CommonService } from "../../common-service";
import { ListBatchMonitoringResponse } from "../../responses/srvlog/list-batch-monitoring.response";
import { BatchMonitoringResponse } from "../../responses/srvlog/batch-monitoring.response";
import { AppConfigService } from "src/app/app-config.service";
import { ApiEnum } from "src/app/shared/enum/api.enum";
import { EndpointBuilderService } from "../../endpint-builder.service";

@Injectable({
  providedIn: 'root'
})
export class BatchMonitoringService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient,
    configService: AppConfigService,
    private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listBatch(): Observable<ListBatchMonitoringResponse> {

    let uri = 'BatchMonitoring'

    return this.httpClient.get<ListBatchMonitoringResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSrvLog) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public getProjectLogs(
    idBatchConfig: number,
    status: number = null,
    searchText: string = null,
    start: string = null,
    end: string = null,
    pageIndex: number = 0): Observable<BatchMonitoringResponse> {

    let uri = `BatchMonitoring/idBatchConfig/${idBatchConfig}?`;

    if (status)
      uri += `status=${status}&`
    if (searchText)
      uri += `searchText=${searchText}&`
    if (start)
      uri += `start=${start}&`
    if (end)
      uri += `end=${end}&`

    uri += `pageIndex=${pageIndex}`

    return this.httpClient.get<BatchMonitoringResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSrvLog) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
